import axios from 'axios';
import { toast } from 'react-toastify';

const axiosInstance = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  },
});

// Request Interceptor — Inject token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const selectedUser = localStorage.getItem('marketplaceAcc');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ⚙️ Only set marketplace-id if not already manually set by caller
    if (!config.headers['marketplace-id'] && selectedUser) {
      try {
        const parsedUser = JSON.parse(selectedUser);
        if (parsedUser && parsedUser.id) {
          config.headers['marketplace-id'] = parsedUser.id;
        }
      } catch (e) {
        console.warn('Failed to parse selected user:', e);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// Response Interceptor — Centralized Error Handling
axiosInstance.interceptors.response.use(
  (response) => {

    // Handle explicit success: false from backend
    if (response?.data?.success === false) {
      const message = response.data.message || 'Request failed.';
      toast.error(message, {
        position: 'bottom-right',
        autoClose: 5000,
      });
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data || {};
    const token = localStorage.getItem('token');
    let errorMessage = data.message || 'Something went wrong.';

    // Collect validation errors if available
    if (data?.errors && typeof data.errors === 'object') {
      const validationMessages = Object.values(data.errors).flat();
      if (validationMessages.length > 0) {
        errorMessage = validationMessages.join(', ');
      }
    }

    if(status === 403 ){
      return 
    }

    // Handle errors based on status and login state
   else if (status === 401) {
      // Unauthorized
      if (token) {
        // Token is present — session expired or invalid
        toast.error('Session expired. Please log in again.', {
          position: 'bottom-right',
          autoClose: 5000,
        });
        localStorage.removeItem('token');
        localStorage.removeItem('marketplaceAcc');
        window.location.href = '/signin'; // optional redirect
      } else {
        toast.error(errorMessage || 'Invalid credentials.', {
          position: 'bottom-right',
          autoClose: 5000,
        });
      }
    }  else if (status === 404) {
      toast.error('Requested resource not found.', {
        position: 'bottom-right',
        autoClose: 5000,
      });
    } 
    else if (status === 422) {
      toast.error(data?.error || data?.errors?.[0]||errorMessage, {
        position: 'bottom-right',
        autoClose: 5000,
      });
    }
    else if (status === 500) {
      toast.error('Server error. Please try again later.', {
        position: 'bottom-right',
        autoClose: 5000,
      });
    } else {
      // Other status or fallback
      toast.error(errorMessage, {
        position: 'bottom-right',
        autoClose: 5000,
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
